import axios from 'axios'
import { API_BASE, apiErrorHandler, ApiFilter } from '../api'
import Auth from '../auth'
import { objectToSnakeCase } from '../utils'

const ANONYMOUS_DONOR_URL = `${API_BASE}anonymous-donors/`
const SUBSCRIBE_URL = `${API_BASE}anonymous-donors/subscribe/`
const UNSUBSCRIBE_URL = `${API_BASE}anonymous-donors/unsubscribe/`

export default class AnonymousDonorAPI {
  constructor(cls) {
    this.cls = cls
  }

  static create(cls) {
    return new AnonymousDonorAPI(cls)
  }

  /* Create an AnonymousDonor, and (optional) Stripe account. */
  create(anonymousDonor, stripeToken = undefined) {
    // Set stripeToken as undefined by default to remove it from data if it's missing
    const data = objectToSnakeCase({ ...anonymousDonor, stripeToken })
    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
    }
    return axios
      .post(ANONYMOUS_DONOR_URL, data, options)
      .then(res => this.cls.fromAPI(res.data))
      .catch(apiErrorHandler({ apiName: 'Create Anonymous Donor API error' }))
  }

  async retrieve(anonymousDonorId, params = {}) {
    const paramsMap = {
      donorId: ApiFilter.create({ key: 'donor_id' }),
      magicToken: ApiFilter.create({ key: 'magic_token' }),
    }
    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
      params: ApiFilter.buildParams(paramsMap, { ...params }),
    }

    const url = `${ANONYMOUS_DONOR_URL}${anonymousDonorId}/`
    return axios
      .get(url, options)
      .then(response => response.data)
      .then(this.cls.fromAPI)
      .catch(apiErrorHandler({ apiName: 'Retrieve Anonymous Donor API error' }))
  }

  /*
   * Start a recurring donation for an authenticated user.
   */
  async startRecurringDonation(amount, params) {
    const paramsMap = {
      donorId: ApiFilter.create({ key: 'donor_id' }),
      magicToken: ApiFilter.create({ key: 'magic_token' }),
    }
    const data = { amount: amount }
    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
      params: ApiFilter.buildParams(paramsMap, { ...params }),
    }
    return axios
      .post(SUBSCRIBE_URL, data, options)
      .then(response => response.data)
      .then(this.cls.fromAPI)
      .catch(apiErrorHandler({ apiName: 'Start Recurring Donation API error' }))
  }

  /*
   * Cancel all recurring donations for an anonymous donor.
   */
  async cancelRecurringDonations(authParams, subscriptionId) {
    const paramsMap = {
      donorId: ApiFilter.create({ key: 'donor_id' }),
      magicToken: ApiFilter.create({ key: 'magic_token' }),
    }
    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
      params: ApiFilter.buildParams(paramsMap, { ...authParams }),
    }
    return axios
      .post(UNSUBSCRIBE_URL, { subscription_id: subscriptionId }, options)
      .then(response => response.data)
      .then(this.cls.fromAPI)
      .catch(apiErrorHandler({ apiName: 'Cancel Recurring Donation API error' }))
  }
}
